import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSnowflake } from '@fortawesome/free-solid-svg-icons';

const CoolActivitiesIcon = ({ size = 22, color = 'currentColor', className, onClick }) => (
  <FontAwesomeIcon
    icon={faSnowflake}
    className={className}
    onClick={onClick}
    style={{ fontSize: size, color, width: '1em', height: '1em', cursor: onClick ? 'pointer' : undefined }}
  />
);

export default CoolActivitiesIcon;
